export default "__VITE_PUBLIC_ASSET__1f332248__"